import { render } from "./InnerBox.vue?vue&type=template&id=6e28e17a&scoped=true"
import script from "./InnerBox.vue?vue&type=script&lang=js"
export * from "./InnerBox.vue?vue&type=script&lang=js"

import "./InnerBox.vue?vue&type=style&index=0&id=6e28e17a&scoped=true&lang=scss"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-6e28e17a"]])

export default __exports__